import { Api } from '../api';
import { transferRequests } from '../endpoints';
import type { ApiPaginate, ApiResponse } from '../../models';
import type {
  FeeRequest,
  TransferCreateRequest,
  TransferReasonsResponse,
  TransferRequestCreateDocumentRequest,
  TransferRequestDeleteDocumentRequest,
  TransferRequestDocumentResponse,
  TransferRequestDownloadDocumentRequest,
  TransferRequestDownloadDocumentResponse,
  TransferRequestGetDocumentsRequest,
  TransferRequestGetFxRateRequest,
  TransferRequestGetListRequest,
  TransferRequestLimitsResponse,
  TransferRequestResponse,
  TransferRequestUpdateRequest,
  TransferRequestUpdateStatusRequest,
} from './models';

export class TransferRequestsApi extends Api {
  static getFee = (request: FeeRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<number>>({ url: transferRequests.getFee(), queryParams: request, signal });

  static getList = (request: TransferRequestGetListRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<TransferRequestResponse[]>>({ url: transferRequests.getList(), queryParams: request, signal });

  static create = (request: TransferCreateRequest, signal?: AbortSignal) =>
    this.post<TransferCreateRequest, ApiResponse<TransferRequestResponse>>({ url: transferRequests.create(), data: request, signal });

  static update = (request: TransferRequestUpdateRequest, signal?: AbortSignal) =>
    this.put<TransferRequestUpdateRequest, ApiResponse<TransferRequestResponse>>({ url: transferRequests.update(), signal, data: request });

  static updateStatus = (request: TransferRequestUpdateStatusRequest, signal?: AbortSignal) =>
    this.put<TransferRequestUpdateStatusRequest, ApiResponse<TransferRequestResponse>>({
      url: transferRequests.updateStatus(),
      data: request,
      signal,
    });

  static getDocuments = (request: TransferRequestGetDocumentsRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<TransferRequestDocumentResponse[]>>({ url: transferRequests.getDocuments(), queryParams: request, signal });

  static downloadDocument = (request: TransferRequestDownloadDocumentRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<TransferRequestDownloadDocumentResponse>>({ url: transferRequests.downloadDocument(), queryParams: request, signal });

  static createDocument = ({ transferRequestId, file }: TransferRequestCreateDocumentRequest, signal?: AbortSignal) => {
    const formData = new FormData();
    formData.append('file', file);

    return this.post<FormData, ApiResponse<string>>({
      url: transferRequests.createDocument(),
      queryParams: { transferRequestId },
      data: formData,
      signal,
    });
  };

  static deleteDocument = (request: TransferRequestDeleteDocumentRequest, signal?: AbortSignal) =>
    this.delete<null, ApiResponse<string>>({ url: transferRequests.deleteDocument(), queryParams: request, signal });

  static getLimits = (signal?: AbortSignal) => this.get<ApiResponse<TransferRequestLimitsResponse>>({ url: transferRequests.getLimits(), signal });

  static getTransferReasons = (signal?: AbortSignal) =>
    this.get<ApiResponse<TransferReasonsResponse[]>>({ url: transferRequests.getTransferReasons(), signal });

  static getFxRate = (request: TransferRequestGetFxRateRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<number>>({ url: transferRequests.getFxRate(), queryParams: request, signal });
}
